// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileEmptyState-cls1_qxW","cls2":"ProfileEmptyState-cls2_Ak4 ProfileEmptyState-cls1_qxW"};